<template lang="pug">
section(v-bind:class="sectionClass")
	.section-content
		.columns.is-valigned-end
			.column.column-app-phone1
				p.subtitle.no-line-break-mobile(style="width: 100%; max-width:90vw; margin-bottom: 1rem; font-size: 1.5rem;")
					strong {{ $t('home.section_intro.app_name') }}
				p.subtitle.no-line-break-mobile
					| {{ $t('home.section_intro.title1') + ' ' }}
					| {{ $t('home.section_intro.title2') }}

				.is-hidden-mobile(style="width: 100%")
					intro-partners

			.column.is-narrow.column-app-phone2(v-if="itLang")
				img.block(src="/img/phone-it.png" :alt="$t('alt.app')" draggable="false")
			.column.is-narrow.column-app-phone2(v-else)
				img.block(src="/img/phone-en.png" :alt="$t('alt.app')" draggable="false")

			.column.no-padding-top.is-hidden-tablet
				intro-partners
</template>

<script>
import IntroApp from './elements/IntroApp.vue'
import IntroPartners from './elements/IntroPartners.vue'

export default {
	name      : 'SectionIntro',
	components: {
		IntroApp,
		IntroPartners
	},
	props: {
		num: Number
	},
	computed: {
		itLang() {
			return this.$t('locale.lang') === 'it'
		},
		sectionClass() {
			return {
				'section'                : true,
				'border-bottom-section'  : true,
				'section-background-grey': this.num % 2 === 0
			}
		}
	}
}
</script>
